import { OnInit, Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { LoggerService } from '../../services';
import { IJobAlertSettings } from '../../interfaces/job-alert-settings';
import { JobAlertService } from '../../services';
import { JobAlertSettingsEditComponent } from './job-alert-settings-edit.component';

@Component({
  selector: 'job-alert-settings-admin',
  templateUrl: './job-alert-settings-admin.component.html',
  styleUrls: ['./job-alert-settings-admin.component.scss'],
})
export class JobAlertSettingsAdminComponent implements OnInit {
  @ViewChild(JobAlertSettingsEditComponent) editComponent;

  public editMode: boolean = false;
  public alertSettingList: IJobAlertSettings[] = [];
  public jobAlertSettingId?: number;
  public settingsLoaded: boolean = false;

  constructor(private jobAlertService: JobAlertService, private loggerService: LoggerService) {}

  ngOnInit() {
    this.jobAlertService.getDefaultSettings().then((x) => {
      this.editMode = true;
      this.editComponent.editAlertSetting(x);
    });
  }

  ngAfterViewInit() {}

  editModeChange($event: boolean) {}
}
